import React, {  Component } from 'react'
import ReactDOM from 'react-dom/client';
import Apprt from '../App.js';
//import AdmDashboard from './components/AdminDashboard.js';

import axios from 'axios';
import { removeUserSession, setUserSession,aPIURL,auTHURL } from '../utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CDashboard from '../components/ClientApplication/CDashboard.js';
import Modal from '../components/LoginModal.js';
import PriceList from '../components/PriceList.js';
import PublicNav from './PublicNav.js'
import PublicFooter from './PublicFooter.js'
import $ from 'jquery';


//class ShareMonitoring extends React.Component 
function ShareMonitoring(props) 
{
   
     
      
       return (   <>
       
       <div>{props.token}</div>
      </>
        
      );
   
  }
  
  //const root = ReactDOM.createRoot(document.getElementById('root'));
 // root.render(<ShareMonitoring/>);
  
  
  export default ShareMonitoring;
